module.exports = __webpack_public_path__ + "img/reisen udongein inaba_lw.fae0e5f7.png";